import { HelpCenterArticleProps } from '@/organisms/HelpCenterArticle/ts'

export function getHelpCenterArticleProps(
  output: string,
  title: string,
  sectionsList: string[][]
): HelpCenterArticleProps {
  return {
    output,
    title,
    sections: sectionsList.map(([title, ...hrefs]) => ({
      title,
      i18nKey: title + '_desc',
      hrefs,
    })),
  }
}
